/**
 * Public article indexing helpers — keep published article URLs Google-indexable.
 */

/** True when a robots directive blocks indexing. */
export function isNoindexRobots(robots) {
  return String(robots || '').toLowerCase().includes('noindex');
}

/**
 * Normalize robots for public article pages.
 * Published articles must always be indexable; ignore accidental admin noindex.
 */
export function resolvePublicArticleRobots(robots) {
  const normalized = String(robots || 'index, follow')
    .split(',')
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean);

  if (!normalized.length || normalized.includes('noindex')) {
    return 'index, follow';
  }

  const index = normalized.includes('index') ? 'index' : 'index';
  const follow = normalized.includes('nofollow') ? 'nofollow' : 'follow';
  return `${index}, ${follow}`;
}
